import { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PricingOnRequest, SvgIcon } from '@/components';
import { PlanCategoryEnum, tariffDisplayData } from '@/config';

import styles from './TariffsProPlusDetails.module.sass';

const ACCENT_COLOR = tariffDisplayData[PlanCategoryEnum.PRO_PLUS].color;

const FEATURE_ICONS = [
  'risk',
  'connect',
  'dashboard',
  'compliance-dashboard',
  'monitoring',
  'scan-verify',
  'investigations',
  'question-circle',
];

interface TariffsProPlusDetailsProps {}

const TariffsProPlusDetails: FC<TariffsProPlusDetailsProps> = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FEATURE_ICONS[0],
      title: t('translation.tariffs_pro_plus_feature_risk_title'),
      text: t('translation.tariffs_pro_plus_feature_risk_text'),
    },
    {
      icon: FEATURE_ICONS[1],
      title: t('translation.tariffs_pro_plus_feature_connected_title'),
      text: t('translation.tariffs_pro_plus_feature_connected_text'),
    },
    {
      icon: FEATURE_ICONS[2],
      title: t('translation.tariffs_pro_plus_feature_sources_title'),
      text: t('translation.tariffs_pro_plus_feature_sources_text'),
    },
    {
      icon: FEATURE_ICONS[3],
      title: t('translation.tariffs_pro_plus_feature_counterparty_title'),
      text: t('translation.tariffs_pro_plus_feature_counterparty_text'),
    },
    {
      icon: FEATURE_ICONS[4],
      title: t('translation.tariffs_pro_plus_feature_monitoring_title'),
      text: t('translation.tariffs_pro_plus_feature_monitoring_text'),
    },
    {
      icon: FEATURE_ICONS[5],
      title: t('translation.tariffs_pro_plus_feature_kyt_title'),
      text: t('translation.tariffs_pro_plus_feature_kyt_text'),
    },
    {
      icon: FEATURE_ICONS[6],
      title: t('translation.tariffs_pro_plus_feature_investigations_title'),
      text: t('translation.tariffs_pro_plus_feature_investigations_text'),
    },
    {
      icon: FEATURE_ICONS[7],
      title: t('translation.tariffs_pro_plus_feature_support_title'),
      text: t('translation.tariffs_pro_plus_feature_support_text'),
    },
  ];

  return (
    <div
      className={styles.details}
      style={{ '--pro-plus-accent': ACCENT_COLOR } as CSSProperties}
    >
      <div className={styles.main}>
        <div className={styles.features}>
          {features.map((feature) => (
            <div key={feature.title} className={styles.feature}>
              <div className={styles.featureIcon}>
                <SvgIcon name={feature.icon} className={styles.featureSvg} />
              </div>
              <div className={styles.featureBody}>
                <div className={styles.featureTitle}>{feature.title}</div>
                <div className={styles.featureText}>{feature.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <PricingOnRequest color={ACCENT_COLOR} className={styles.pricing} />
    </div>
  );
};

export default TariffsProPlusDetails;
